import {Component,type ReactNode} from "react";
import {useTranslation} from "react-i18next";
import {Button} from "@secretaa/ui";
function Failure({retry}:{retry:()=>void}){
 const {t}=useTranslation();
 return <section role="alert" className="space-y-3 rounded-lg border border-(--saa-border) p-4"><h2 className="font-semibold">{t("surfaces.render.failedTitle")}</h2><p>{t("surfaces.render.failedBody")}</p><Button variant="secondary" onClick={retry}>{t("surfaces.render.retryDisplay")}</Button></section>;
}
class Boundary extends Component<{children:ReactNode},{failed:boolean}>{
 override state={failed:false};
 static getDerivedStateFromError(){return {failed:true};}
 override render(){return this.state.failed?<Failure retry={()=>this.setState({failed:false})}/>:this.props.children;}
}
/** Only display is retried. This boundary has no source/command/provider or business-run access. */
export function SurfaceErrorBoundary({frameKey,children}:{frameKey:string;children:ReactNode}){
 return <Boundary key={frameKey}>{children}</Boundary>;
}
